import { render, staticRenderFns } from "./AddUpdateCarousel.vue?vue&type=template&id=3130e154"
import script from "./AddUpdateCarousel.vue?vue&type=script&lang=js"
export * from "./AddUpdateCarousel.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateCarousel.vue?vue&type=style&index=0&id=3130e154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports